import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'

import styled from 'styled-components'

import { BrowserRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'

import { createGlobalStyle } from 'styled-components'

import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'

import ptBr from 'date-fns/locale/pt-BR'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import MuiCircularProgress from '@material-ui/core/CircularProgress'

import CsgErrorBoundary from 'components/organisms/ErrorBoundary'
import CsgSnackbarProvider from 'components/organisms/SnackbarProvider'
import CsgCentralizedTemplate from 'components/templates/Centralized'
import theme from 'app/theme'
import config from 'app/config'
import { Provider as CsgProvider } from 'app/context'
import store from 'store'

import CsgApp from 'App'

import 'app/i18n'
import 'app/fonts/consigna-icons.css'
import 'app/yupMethods'
import { UserNavigationBlocker } from 'app/utils'

const isIE = /*@cc_on!@*/ false || !!document.documentMode
if (isIE) require('core-js')

const CsgGlobalCss = createGlobalStyle`
  @media print {
    body {
      background-color: ${theme.palette.grey[100]} !important;
      -webkit-print-color-adjust: exact;
    }
  }
`
const Progress = styled(MuiCircularProgress)`
  && {
    color: ${theme.palette.primary.main};
  }
`

ReactDOM.render(
  <Suspense
    fallback={
      <CsgCentralizedTemplate>
        <Progress />
      </CsgCentralizedTemplate>
    }
  >
    <ReduxProvider store={store}>
      <CsgProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBr}>
          <MuiThemeProvider theme={theme}>
            <BrowserRouter
              basename={config.basename}
              getUserConfirmation={(message, callback) => {
                return UserNavigationBlocker(message, callback)
              }}
            >
              <CsgErrorBoundary>
                <CssBaseline />
                <CsgGlobalCss />
                <CsgSnackbarProvider>
                  <CsgApp />
                </CsgSnackbarProvider>
              </CsgErrorBoundary>
            </BrowserRouter>
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </CsgProvider>
    </ReduxProvider>
  </Suspense>,
  document.getElementById('root')
)
